import React from "react";
import { useSelector, shallowEqual } from "react-redux";
import AddFAQ from "./AddFaq";
import {
  Card,
  CardHeader,
  CardBody,
} from "../../../../../_metronic/_partials/controls";
import { Link } from "react-router-dom";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";

export const FaqPageDetail = () => {
  const { selectedFAQ, reDirect } = useSelector(
    (state) => state.faq,
    shallowEqual
  );

  return (
    <>
      <Card>
        <CardHeader
          title={
            <>
              <div className="form-group m-0 d-flex align-items-center">
                <Link className="btn btn-link px-0" to="/faq-pages">
                  <SVG
                    className="h-50 align-self-center"
                    src={toAbsoluteUrl(
                      "/media/svg/icons/Navigation/Arrow-left.svg"
                    )}
                  />
                  Back
                </Link>
                <span className="pl-2">
                  {selectedFAQ.question ? "Edit FAQ" : "Add FAQ"}
                </span>
              </div>
            </>
          }
        ></CardHeader>
        <CardBody>
          <AddFAQ selectedFAQ={selectedFAQ} reDirect={reDirect} />
        </CardBody>
      </Card>
    </>
  );
};
